import { map } from 'rxjs/operators';
import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApplicationSubType, Inspection } from '../models';
import { ApplicationType } from '../../utils/enums/applicationType.enum';

@Injectable({
  providedIn: 'root'
})
export class ShareService {
  constructor(private apiService: ApiService) { }

  public shareReport(params: any): Observable<boolean> {
    const url = '/shares/';
    return this.apiService.post(url, params).pipe(
      map(() => {
        return true;
      })
    );
  }

  public createEmptyShare(params: any): Observable<any> {
    return this.apiService.post('/shares/empty', params);
  }

  public getShareData(reportId: string): Observable<any> {
    const url = `/shares/${reportId}`;
    return this.apiService.get(url);
  }

  public generateMessage(inspection: Inspection, shareData: any) {
    var equipmentList = '';
    if (shareData.EquipmentList && shareData.EquipmentList.length > 0) {
      equipmentList = shareData.EquipmentList.map((equipment: any) => {
        return equipment.EquipmentType ? `${equipment.EquipmentType} (${equipment.EquipmentId})` : equipment.EquipmentId;
      }).join(', ');
    } else {
      equipmentList = `${shareData.EquipmentType} (${shareData.EquipmentId})`;
    }

    if (inspection.applicationType === ApplicationType.Optimization)
      return `Dear Customer,
    \nFollowing the assessment of your ${equipmentList} performed by ${shareData.TechnicianName}, please find attached a copy of your ${shareData.InspectionType} Report including the identified areas of improvement and recommendations. The objective of your report is to provide an in-depth analysis of your equipment as well as provide the steps to reach higher productivity targets.
    \nPlease don’t hesitate to call your Performance Solutions Manager if you have any questions regarding your Process Optimization report.
    \nBest regards.`;

    if (inspection.applicationType === ApplicationType.Installation) {
      if (inspection.applicationSubType === ApplicationSubType.Instruction)
        return `Dear Customer,
        \nFollowing the last training intervention carried out on your premises concerning your ${equipmentList}, please find enclosed our report.
        \nPlease do not hesitate to contact your Bobst contact person if you have any questions regarding this report.
        \nBest regards,`;
      if (inspection.applicationSubType === ApplicationSubType.PreInstallation)
        return `Dear Customer,
        \nFollowing the last pre-installation visit carried out on your premises concerning your ${equipmentList}, please find enclosed our report.
        \nPlease do not hesitate to contact your Bobst contact person if you have any questions regarding this report.
        \nBest regards,`;
      // default : installation
      return `Dear Customer,
        \nFollowing the last installation intervention carried out on your premises concerning your ${equipmentList}, please find enclosed our report.
        \nPlease do not hesitate to contact your Bobst contact person if you have any questions regarding this report.
        \nBest regards,`;
    }

    // default : maintenance
    return `Dear Customer,
    \nFollowing the technical inspection of your ${equipmentList} performed by ${shareData.TechnicianName}, please find attached a draft copy of your ${shareData.InspectionType} Report including the checkpoints and the condition of the machine. The objective of your report is to structure your yearly planned maintenance session in order to prepare in detail the maintenance activities required. Following on from the draft report attached you will receive shortly the finalised copy and spare parts quotation. At this stage you may want to consider booking your BOBST technician for any required maintenance session.
    \nPlease don’t hesitate to call your Performance Solutions Manager if you have any questions regarding your Maintenance plan.
    \nBest regards.`;

  }
}
